import ErrorBoundary from './ErrorBoundary';
import { ProspectFooterDefault, type FooterPropsType } from './ProspectFooterDefault';

export const ProspectFooter = (props: FooterPropsType) => (
  <ErrorBoundary>
    <ProspectFooterDefault {...props} />
  </ErrorBoundary>
);

export default ProspectFooter;
